module.exports = __webpack_public_path__ + "media/svg-new/home-964713cf.svg";